import React, { CSSProperties } from 'react';
import styles from './Title.module.css';
export const Title = ({ title, style }: { title: string; style?: CSSProperties; className?: string }) => (
  <div className={styles['title_title']} style={style}>
    {title}
  </div>
);
